import React, { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import AuthProvider from '../src/context/AuthProvider';
import Loader from "./common/Loader";

const SchoolRoutes = lazy(() => import("../src/routes/SchoolRoutes"));
const ErpRoutes = lazy(() => import("../src/routes/ErpRoutes"));

function App() {
  return (
    <>
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path="/*" element={<SchoolRoutes />} />
          <Route path="/school-erp/*" element={<AuthProvider><ErpRoutes /></AuthProvider>} />
        </Routes>
      </Suspense>
    </>
  );
}

export default App;
